import { useMemo } from "react";
import SplashScreen from "../components/SplashScreen";

const LOGO_URL = "/criye-logo.png";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  // Build Google OAuth URL eagerly so we can render an <a target="_top"> link.
  // Using a real <a target="_top"> is the most reliable way to escape an iframe
  // (e.g. Emergent's preview panel) — Google's accounts.google.com rejects
  // being loaded inside any frame, so a JS-driven window.location.href would
  // fail in that context with ERR_BLOCKED_BY_RESPONSE.
  const googleAuthUrl = useMemo(() => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri = window.location.origin + "/auth/google";
    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: "code",
      scope: "openid email profile",
      access_type: "online",
      prompt: "select_account",
      include_granted_scopes: "true",
    });
    return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  }, []);

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center px-4">
      <SplashScreen />
      <div
        className="absolute inset-0 z-0"
        style={{
          background: "radial-gradient(ellipse at 30% 20%, rgba(0,176,255,0.15) 0%, transparent 50%), radial-gradient(ellipse at 70% 80%, rgba(0,255,212,0.12) 0%, transparent 50%), #050505",
        }}
      />
      <div
        className="absolute inset-0 z-0 opacity-30"
        style={{
          backgroundImage: "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-10">
          <img src={LOGO_URL} alt="CRIYE" className="w-32 h-32 mx-auto mb-4 drop-shadow-[0_0_24px_rgba(0,255,212,0.4)]" />
          <h1 className="text-4xl sm:text-5xl font-heading font-bold text-white tracking-tight">
            <span className="text-brand-gradient">CRIYE</span>
          </h1>
          <p className="text-xs tracking-[0.3em] uppercase text-zinc-500 mt-2 font-mono">Control Interno</p>
        </div>

        <div className="glass-card rounded-xl p-8 shadow-2xl">
          <h2 className="text-xl font-heading font-semibold text-white mb-2">Bienvenido de vuelta</h2>
          <p className="text-sm text-zinc-400 mb-8">Inicia sesión para acceder al panel de control de tu negocio.</p>

          <a
            href={googleAuthUrl}
            target="_top"
            rel="noopener"
            data-testid="login-google-btn"
            className="w-full bg-white text-black font-semibold py-3 px-6 rounded-md hover:opacity-90 transition-opacity flex items-center justify-center gap-3 group cursor-pointer"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continuar con Google
          </a>

          <div className="mt-8 pt-6 border-t border-white/5">
            <p className="text-xs text-zinc-500 font-mono leading-relaxed text-center">
              Repuestos · Herramientas · Accesorios para celulares
            </p>
          </div>
        </div>

        <p className="text-center text-xs text-zinc-600 mt-8 font-mono">
          v1.0 · Sistema interno protegido
        </p>
      </div>
    </div>
  );
}
